<template>
  <div ref="dropdown" class="language-dropdown">
    <button
      class="language-dropdown__btn flex ttc btn btn--text items-center bg-transparent"
      style="margin-left: auto;"
      ref="dropdownButton"
      @click="handleLanguageDropdownClick"
      @keydown.esc="closeLanguageDropdown"
    >
      {{selectedLanguage}}
      <span class="fw3 ml1 moon-gray">|</span>
      <!-- icon down triangle -->
      <div class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M7 10l5 5 5-5z"></path>
          <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
      </div>
    </button>

    <div @blur="onBlur" ref="dropdownList" tabindex="0">
      <ul class="language-dropdown__list" v-if="languageDropdownVisible">
        <li>
          <p class="text">› {{$t('selectLanguage')}}</p>
        </li>

        <li v-for="language in languages" :key="language.language">
          <a
            @click="handleClose(language.language)"
            :id="language.title"
            class="link"
            :class="{'language-selected': (getLanguage() === language.language)}"
            href="#"
          >{{language.title}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getLanguage, getPathNameFromRouteName, findElementInChildren } from '@/utils/common';

export default {
  data() {
    return {
      languageDropdownVisible: false,
      languages: [
        { flag: 'us', language: 'en-us', title: 'English' },
        { flag: 'fr', language: 'fr', title: 'Français' },
        { flag: 'it', language: 'it', title: 'Italiano' },
        { flag: 'ja', language: 'ja', title: '日本人' },
        { flag: 'pt', language: 'pt', title: 'Português' },
        { flag: 'es', language: 'es', title: 'Español' }
      ]
    };
  },
  computed: {
    selectedLanguage() {
      let selectedLanguageObject = this.languages.find(language => {
        return getLanguage() === language.language;
      });
      return selectedLanguageObject.title;
    }
  },
  methods: {
    ...mapActions(['changeLanguage']),
    getLanguage: getLanguage,
    handleClose(language) {
      let originalLocation = window.location.href;
      /* eslint-disable no-useless-escape */
      let regex = new RegExp(`\/${getLanguage()}`, 'g');
      this.changeLanguage(language).then(() => {
        let redirectPathName = getPathNameFromRouteName(this.$route.name, this.$router);
        if (redirectPathName) {
          window.location.href = `/${language}/${redirectPathName.replace(/ /g, '-')}`;
        } else {
          window.location.href = originalLocation.replace(regex, `/${language}`);
        }
      });
    },
    toggleOpenState() {
      this.languageDropdownVisible = !this.languageDropdownVisible;
    },
    handleLanguageDropdownClick() {
      this.toggleOpenState();
      console.log(this.$refs.dropdownList);
      if (this.$refs.dropdownList) {
        this.$refs.dropdownList.focus();
      }
    },
    closeLanguageDropdown() {
      this.languageDropdownVisible = false;
    },
    onBlur(e) {
      const children = Array.from(this.$refs.dropdownList.children);
      const target = e.relatedTarget;

      const found = children.find(child => findElementInChildren(child, target));

      if (!found) {
        this.languageDropdownVisible = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.language-dropdown {
  position: relative;
  z-index: 2;
}
.language-dropdown__list {
  z-index: 2;
  position: absolute;
  text-align: left;
  background-color: #ffffff;
  text-decoration: none;
  border: 1px solid #6b90da;
  overflow: hidden;
  padding: 4px;
  margin: 0.3rem 0 0 0;
  border-radius: 5px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  animation: bounce 0.6s ease-out;

  .text {
    margin: 0;
    padding: 0.2rem;
    font-weight: 600;
    color: #000;
    font-size: 0.9rem;
  }
  .link {
    padding: 0.2rem;
    color: #0000cc;
    font-weight: 300;
    font-family: arial;
    font-size: 0.85rem;
  }
  .text,
  .link {
    display: block;
    margin-bottom: 0.02rem;
  }
}

.language-selected {
  font-weight: 600 !important;
}
</style>
